var _circle, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#F5F5F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1736 18.7442C20.0625 18.7331 19.9292 18.7331 19.8069 18.7442C17.1625 18.6553 15.0625 16.4887 15.0625 13.822C15.0625 11.0998 17.2625 8.88867 19.9958 8.88867C22.7181 8.88867 24.9292 11.0998 24.9292 13.822C24.9181 16.4887 22.8181 18.6553 20.1736 18.7442Z",
    fill: "#D0D0D0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6182 22.8453C11.9293 24.6453 11.9293 27.5786 14.6182 29.3675C17.6738 31.412 22.6849 31.412 25.7405 29.3675C28.4293 27.5675 28.4293 24.6342 25.7405 22.8453C22.696 20.812 17.6849 20.812 14.6182 22.8453Z",
    fill: "#D0D0D0"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user-icon.e44d8a0ee5542d4fbc848a5f2f7cb47d.svg";
export { ForwardRef as ReactComponent };